<template>
  <div
    class="project-structure-plan-edge-point"
    :style="`
      left: ${coordinates.x * model_zoom}px;
      top: ${coordinates.y * model_zoom}px;
      `"
    >
  </div>
</template>
<script>
  export default {
    props: ['coordinates', 'model_zoom'],
    data: () => ({
    }),
  }
</script>
<style>
  .project-structure-plan-edge-point {
    position: absolute;
    z-index: 50;
    height: 5px;
    width: 5px;
    background-color: red;
    margin-left: -2px;
    margin-top: -2px;
    border-radius: 5px;
    cursor: pointer !important;
  }
  .project-structure-plan-edge-point:hover {
    height: 10px;
    width: 10px;
    margin-left: -5px;
    margin-top: -5px;
    border-radius: 10px;
  }
</style>
